import moment from 'moment-timezone';

/* Klasa zawiera metody służące tworzeniu stanów store lub ich częsci - pomocna w dynamicznym tworzeniu stanu zakładek */
class TemplateMaker {
  /* Generuj domyślny stan dla Tabeli wraz z filtrami, sortowaniem, paginacją */
  table = (): ViewDataSet => {
    return {
      initTable: true,
      data: [],
      dataAttendanceList: [],
      totalPage: 0,
      totalRecords: 0,
      page: 1,
      loading: false,
      loadingPage: false,
      loadingDetails: false,
      errorDetails: false,
      error: false,
      cache: {
        duration: moment.now(),
        syncInProgress: false,
        controlSum: '',
        isUpToDate: true,
        error: false,
      },
      marksColumns: [],
      expanded: null,
      columnsToPrint: [],
      columnsToAttendanceList: [],
      sorting: {
        columnName: undefined,
        order: undefined,
      },
      search: '',
      selected: [],
      columns: [],
      filters: {
        allFilters: [],
        loading: false,
        error: false,
      },
      userColumnsSetup: { //klucze kolumn posortowane wg. danych z user_config
        main: [],
        details: [],
      },
      isWKD: false,
    };
  }
}

export default new TemplateMaker();